import { List, Typography } from 'antd';
import React from 'react'

export const ModalDetalle = ({ data }) => {
    const idComponent = data.id ?? 1;
    if (data.id) delete data.id;
    const campos = Object.entries(data);

    return (
        <List
            key={idComponent}
            dataSource={campos}
            renderItem={(item, index) => (
                <List.Item
                    key={index}
                >
                    <List.Item.Meta
                        title={<Typography.Text strong>{item[0].toUpperCase()}</Typography.Text>}
                        description={item[1]}
                    />
                </List.Item>
            )}
        />
    )
}
